import React, { useCallback } from 'react';
import { useHistory } from 'react-router';
import ExistingClientContent, {
  ButtonsDataType
} from './existing-client.content';
import { PORTAL_TYPE } from '../../../types/app.types';
import { useParamsContext } from '../../../params/params-context';
import getImagePath from '../../../network/services/get-images/get-images.service';

const ButtonsData: ButtonsDataType[] = [];
if (process.env.REACT_APP_LINK_FMER) {
  ButtonsData.push({
    id: 'edenred-redirect-button',
    image: {
      path: getImagePath('button-umer.png'),
      alt: 'intermediaryPages.existingClients.buttons.fmer.alt'
    },
    label: 'intermediaryPages.existingClients.buttons.fmer.label',
    highlighted: 'firmenkunden.mein-edenred.de',
    redirectTo: PORTAL_TYPE.FMER
  });
}
if (process.env.REACT_APP_LINK_ER1) {
  ButtonsData.push({
    id: 'edenred-one-redirect-button',
    image: {
      path: getImagePath('button-edenred-one.png'),
      alt: 'intermediaryPages.existingClients.buttons.edenredOne.alt'
    },
    label: 'intermediaryPages.existingClients.buttons.edenredOne.label',
    highlighted: 'edenred-one.de',
    redirectTo: PORTAL_TYPE.ER1
  });
}
if (process.env.REACT_APP_LINK_EBCLIENT) {
  ButtonsData.push({
    id: 'edenred-ebclient-redirect-button',
    image: {
      path: getImagePath('button-edenred-client.png'),
      alt: 'intermediaryPages.existingClients.buttons.edenredEbClient.alt'
    },
    label: 'intermediaryPages.existingClients.buttons.edenredEbClient.label',
    highlighted: 'nutzer.edenred.de',
    redirectTo: PORTAL_TYPE.EBCLIENT
  });
}

const ExistingClient: React.FunctionComponent = () => {
  const { portalType } = useParamsContext();
  const history = useHistory();

  const redirectTo = useCallback(
    (targetPortal: PORTAL_TYPE): void => {
      let formLink = 'er1-contact-form';
      switch (targetPortal) {
        case PORTAL_TYPE.FMER:
          formLink = 'fmer-contact-form';
          break;
        case PORTAL_TYPE.ER1:
          formLink = 'er1-contact-form';
          break;
        case PORTAL_TYPE.EBUSER:
          formLink = 'eb-user-contact-form';
          break;
        case PORTAL_TYPE.EBCLIENT:
          formLink = 'eb-client-contact-form';
          break;
        default:
          formLink = 'er1-contact-form';
          break;
      }

      history.push(
        portalType !== targetPortal
          ? {
              pathname: '/redirect',
              state: { redirectTo: targetPortal, redirectedFromClients: true }
            }
          : formLink
      );
    },
    [history, portalType]
  );

  return (
    <ExistingClientContent buttonsData={ButtonsData} redirectTo={redirectTo} />
  );
};

export default ExistingClient;
